import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Investors from './pages/Investors';
import AuditLog from './pages/AuditLog';
import Incidents from './pages/Incidents';
import InvestorDetail from './pages/InvestorDetail';
import HashChain from './pages/HashChain';
import RegulatoryMonitor from './pages/RegulatoryMonitor';
import Suitability from './pages/Suitability';
import SuitabilityDetail from './pages/SuitabilityDetail';
import ImpactAssessments from './pages/ImpactAssessments';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Documents from './pages/Documents';
import Settings from './pages/Settings';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Onboarding from './pages/Onboarding';
import SuitabilityAssessment from './pages/SuitabilityAssessment';
import Funds from './pages/Funds';
import FundDetail from './pages/FundDetail';
import FundManagers from './pages/FundManagers';
import Users from './pages/Users';
import SetPassword from './pages/SetPassword';
import Acknowledge from './pages/Acknowledge';
import AML from './pages/AML';
import Migration from './pages/Migration';
import TrustDevice from './pages/TrustDevice';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/trust-device" element={<TrustDevice />} />
        <Route path="/" element={
          <ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>
        } />
        <Route path="/investors" element={
          <ProtectedRoute><Layout><Investors /></Layout></ProtectedRoute>
        } />
        <Route path="/investors/:id" element={
          <ProtectedRoute><Layout><InvestorDetail /></Layout></ProtectedRoute>
        } />
        <Route path="/audit-log" element={
          <ProtectedRoute><Layout><AuditLog /></Layout></ProtectedRoute>
        } />
        <Route path="/incidents" element={
          <ProtectedRoute><Layout><Incidents /></Layout></ProtectedRoute>
        } />
        <Route path="/hash-chain" element={
          <ProtectedRoute><Layout><HashChain /></Layout></ProtectedRoute>
        } />
        <Route path="/regulatory" element={
          <ProtectedRoute><Layout><RegulatoryMonitor /></Layout></ProtectedRoute>
        } />
        <Route path="/impact-assessments" element={
          <ProtectedRoute><Layout><ImpactAssessments /></Layout></ProtectedRoute>
        } />
        <Route path="/suitability" element={
          <ProtectedRoute><Layout><Suitability /></Layout></ProtectedRoute>
        } />
        <Route path="/suitability/:id" element={<Layout><SuitabilityDetail /></Layout>} />
        <Route path="/documents" element={
          <ProtectedRoute><Layout><Documents /></Layout></ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>
        } />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/acknowledge" element={<Acknowledge />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/suitability-assessment" element={<SuitabilityAssessment />} />
        <Route path="/funds" element={
          <ProtectedRoute><Layout><Funds /></Layout></ProtectedRoute>
        } />
        <Route path="/funds/:id" element={
          <ProtectedRoute><Layout><FundDetail /></Layout></ProtectedRoute>
        } />
        <Route path="/fund-managers" element={
          <ProtectedRoute><Layout><FundManagers /></Layout></ProtectedRoute>
        } />
        <Route path="/users" element={
          <ProtectedRoute><Layout><Users /></Layout></ProtectedRoute>
        } />
        <Route path="/aml" element={
          <ProtectedRoute><Layout><AML /></Layout></ProtectedRoute>
        } />
        <Route path="/migration" element={
          <ProtectedRoute adminOnly><Layout><Migration /></Layout></ProtectedRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
};

export default App;